import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "react-i18next";
import { muscleKey, type CatalogMuscleSlug } from "@heraion/shared";

import { joinList } from "../joinList";
import { ToggleRow } from "../primitives/ToggleRow";
import type { UiTheme } from "../theme";

// #492 F5: THE «bodyweight only» switch of today's draft, the same in its
// three doors (Progress, the Home program card, the Create hub). Under it,
// while on, the muscles it left with no exercise: said, never filled with gear.
// F3: the model wizard's suggestions use it too, with their own sublabel.
export function BodyweightOnlyToggle({
  theme,
  value,
  onValueChange,
  noBodyweight,
  sublabel,
}: {
  theme: UiTheme;
  value: boolean;
  onValueChange: (next: boolean) => void;
  /** The muscles the filter left with no exercise. */
  noBodyweight: ReadonlyArray<CatalogMuscleSlug>;
  /** What the switch narrows. Absent: today's session. */
  sublabel?: string;
}) {
  const { t, i18n } = useTranslation();
  const styles = makeStyles(theme);
  return (
    <View>
      <ToggleRow
        theme={theme}
        label={t("progress.planGaps.bodyweightOnly", { defaultValue: "Bodyweight exercises only" })}
        sublabel={
          sublabel ??
          t("progress.planGaps.bodyweightOnlySub", {
            defaultValue: "For today's session: no equipment",
          })
        }
        value={value}
        onValueChange={onValueChange}
      />
      {value && noBodyweight.length > 0 ? (
        <Text style={styles.note}>
          {t("progress.planGaps.noBodyweight", {
            muscles: joinList(
              noBodyweight.map((m) => t(muscleKey(m))),
              i18n.language,
            ),
            defaultValue: "Bodyweight only is on: no exercise for {{muscles}}.",
          })}
        </Text>
      ) : null}
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: ty } = theme;
  return StyleSheet.create({
    note: { color: p.ink2, fontSize: ty.sizes.sm, lineHeight: ty.sizes.sm * 1.4 },
  });
}
